module.exports = new __parcel__URL__("Warriorskill_34.9539066a.png").toString();